import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ethDate } from '../../utils/ethDate';

export default function DateInfo({ createdAt, updatedAt }) {
  return (
    <>
      <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
        {ethDate(updatedAt)}
        : ለመጨረሻ ጊዜ የተስተካከለበት ቀን
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
        {ethDate(createdAt)}
        : የተመዘገበበት ቀን
      </Typography>
    </>
  );
}

DateInfo.propTypes = {
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
};
